





















import Vue from 'vue';

export default Vue.extend({
  name: 'SCircularLoader',
  props: {
    /**
     * The diameter of the loader
     */
    size: {
      type: Number,
      required: true,
    },
    /**
     * The Vuetify theme colour for the spinner.
     * Also supports darken and lighten classes on them/
     * E.g 'neutral darken-1'
     */
    color: {
      type: String,
      required: true,
    },
  },
  computed: {
    borderWidth(): number {
      return this.size > 24 ? 4 : 2;
    },
    /**
     * Take the colours in our 'color' prop and add `--text` to them.
     */
    className(): string[] {
      return this.color.split(' ').map((colour) => {
        // 'darken-2' becomes `text--darken-2`
        if (/^(lighten-\d+)|(darken-\d+)$/.test(colour)) return `text--${colour}`;

        // 'primary' becomes 'primary--text'
        return `${colour}--text`;
      });
    },
  },
});
